/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup MST_002
 * @created at      :   2026/02/12
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    company_cd: '',
    customer_cd: '',
    mdcd: '',
    pageSize: 10,
    pageNo: 1
};

export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.page_no = data.page ?? [];
            state.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        searchMst002Info(context, param) {
            try {
                const searchParam = {
                    company_cd: param.company_cd ?? '',
                    customer_cd: param.customer_cd ?? '',
                    mdcd: param.mdcd ?? '',
                    location_cd: param.location_cd ?? '',
                    pageNo: param.pageNo ?? 1,
                    pageSize: param.pageSize ?? 10,
                    mode: param.mode ?? 0
                };
                repository.searchMst002Info(searchParam).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listData = data.Data?.data ?? [];
                        if (listData.length > 0) {
                            context.commit('setListData', listData);
                        } else {
                            context.commit('setListData', []);
                            context.commit('setMessage', '該当するデータが存在しません');
                        }
                        if (param.callback) {
                            param.callback(data);
                        }
                        const paging = data.Data?.paging ?? { total_rows: 0, page: 1, pagesize: searchParam.pageSize };
                        context.commit('setTotalRows', paging);
                    }
                });
            } catch (e) {
                console.log('searchMst002Info: ' + e.message);
            }
        }
    }
};
